<template>
<div class="visit-sel-prop-wrapper">
  <rich-button
    class="sel-prop-btn"
    :light="true"
    :inline="true"
    :outline="true"
    :primary="true"
    @click="clickBtn"
  >{{placeholder}}</rich-button>
  <span
    class="text"
  >
    <i v-if="classname" :class="'richic-' + classname"></i>
    {{text}}
  </span>
</div>
</template>
<script>
import { mapMutations } from 'vuex'
/**
 * 选择组件 一个按钮 一个展示文案
 * form 表单的展示组件
 * 点击可以触发各种形式的自定义功能
 * props: {
 *  map: {1: '店长'}, (通过value 匹配展示 text)
 *  iconMap: {1: 'right'}, (通过value 匹配展示 icon，可以不传)
 * }
 */
export default {
  name: 'VisitSelProp',
  props: {
    value: {
      required: true,
      type: [String, Number],
      default: ''
    },
    placeholder: {
      required: true,
      type: String
    },
    map: {
      required: true,
      type: [Object, Array]
    },
    iconMap: {
      required: false,
      type: [Object, Array]
    }
  },
  data () {
    return {
      text: '',
      classname: ''
    }
  },
  watch: {
    value (val, oval) {
      if (val !== oval) {
        this.init(val)
      }
      return val
    }
  },
  created () {
    this.init(this.value)
  },
  methods: {
    ...mapMutations('visit', ['updateVisitType']),
    init (val) {
      this.text = this.map[val] || ''
      this.iconMap && (this.classname = this.iconMap[val] || '')
    },
    clickBtn () {
      this.$emit('click', this.clickCB)
    },
    clickCB (data) {
      this.updateVisitType(data)
      this.$emit('input', data)
    }
  }
}
</script>
<style lang="stylus" scoped>
.visit-sel-prop-wrapper
  .sel-prop-btn
    padding: 16px 40px
    min-width: 192px
    line-height: 30px
    font-size: 28px
    color: #ff6325
    background: rgba(252,145,83,.04)
  .text
    font-size: 28px
    .richic-warn
      color: #ff5253
    .richic-right
      color: #31b77e
</style>
